import BUDGET_CONST from './budget-const.js'
import moment from 'moment'
import { createBidAdjustmentForm } from './bid-adjustment.js'

const startDate = moment().format('YYYY-MM-DD')
const endDate = moment().add(2, 'days').format('YYYY-MM-DD')

const defaultTimeSeries = new Array(7 * 48).fill(1).join('')

/**
 * @description: 深度转化优化行为
 */
export const deepConversionBehavior = {
  goal: '', // 深度优化目标
  deep_bid_range: 0, // 深度目标出价类型
  bid_amount: '', // 深度目标出价：固定金额
  deep_deepbid_num_range: [] // 深度目标出价：随机金额
}

/**
 * @description: 深度转化优化ROI
 */
export const deepConversionRoi = {
  // goal: BUDGET_CONST.OPT_GOAL.ONE_DAY_PURCHASE_ROAS,
  goal: '',
  expected_roi: ''
}

/**
 * @description: 预算与出价表单的一些辅助字段，不需要提交
 * @return {*}
 */
const helperFields = {
  dateRange: 1, // 投放时间类型：不限或者指定投放时间
  timeRange: 0, // 投放时段类型：不限或者指定投放时段
  deep_bid_mode: false, // 深度转化优化
  rangeDate: [startDate, endDate] // 指定投放时间
}

export const budgetForm = {
  budget: 0, // 项目日预算
  totalBudget: 0, // 项目总预算
  bid_range: 0, // 出价类型：0固定金额  1随机金额
  daily_budget: '', // 日预算值
  total_budget: '', // 总预算值
  time_series: '', // 指定时间段
  bid_mode: BUDGET_CONST.BID_MODE.OCPM, // 出价方式：OCPM OCPC
  optimization_goal: BUDGET_CONST.OPT_GOAL.APP_ACTIVATE, // 优化目标
  bid_strategy: BUDGET_CONST.BID_STRATEGY.TARGET_COST, // 出价策略
  bid_num_range: [], // 随机金额出价范围
  bid_amount: '', // 固定金额出价

  // 智投优选版位提价
  ...createBidAdjustmentForm(),

  // 智投
  smart_delivery_goal: BUDGET_CONST.SMART_DELIVERY_GOAL.SEVEN_DAY_PURCHASE_ROI, // 智投投放目标
  smart_promotion_spec: {
    register_cost: '', // 注册成本，单位分
    first_day_purchase_roi: '', // 首日付费ROI，小数点3位
    seven_day_purchase_roi: '', // 7日付费ROI
    iaap_roi: '', // 混变ROI目标值
    iaap_mix_in_one_factor: '', // 混变ROI-混变系数，支持三位小数
    day30_purchase_roi: '', // 30日付费ROI
    monetization_roi: '' // 变现ROI系数
  },

  // 智投app-激活与首日付费roi
  game_app_activate_roi_spec: {
    bid_amount: '',
    deep_conversion_worth_rate: ''
  },
  // 智投小游戏-沉默唤起+首日付费ROI
  bid_amount_deep_conversion_worth_rate_spec: {
    bid_amount: '', // 沉默唤起成本（元）
    deep_conversion_worth_rate: '' // 首日付费ROI系数
  },
  // 智投app-激活
  bid_amount_spec: {
    bid_amount: ''
  },

  // v3
  cost_constraint_scene: '', // 可选值：COST_CONSTRAINT_SCENE_OPEN
  custom_cost_cap: '',

  auto_derived_creative_enabled: false, // 是否开启自动衍生视频创意

  auto_acquisition_enabled: false,
  auto_acquisition_budget: '',
  material_package_id: '',
  material_package_name: '',
  bid_scene: BUDGET_CONST.BID_SCENE.NORMAL_AVERAGE,
  searchad_bid_scene: 1,

  ...helperFields,

  deep_conversion_spec: {
    deep_conversion_type: BUDGET_CONST.DEEP_CONVERSION_TYPE.BEHAVIOR, // 深度转化类型
    deep_conversion_worth_spec: deepConversionRoi,
    deep_conversion_behavior_spec: deepConversionBehavior
  },

  search_expansion_switch: BUDGET_CONST.SEARCH_EXPANSION_SWITCH.CLOSE,
  search_expand_targeting_switch: BUDGET_CONST.SEARCH_EXPAND_TARGETING_SWITCH.OPEN,

  access_type: BUDGET_CONST.ACCESS_TYPE.SDK
}
